import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { commonText, kpiReportText } from "../../../locales/en";
import { useDispatch, useSelector } from "react-redux";
import {
  refreshKpiReportData,
  refreshKpiReportDataGet,
  setKpiRequestDataStatus
} from "../../../redux/userReportsSlice";
import KpiRefreshDataModal from "../../../components/modals/KpiRefreshDataModal";
import styles from "./../../../assets/scss/custom.module.scss";

const KpiReportPageAction = ({ subheading }) => {
  const dispatch = useDispatch();
  const { kpiRefreshErrorData, kpiRequestDataStatus } = useSelector(
    (state) => state.userReport
  );

  const [isPolling, setIsPolling] = useState(false);
  const [kpiModal, setKpiModal] = useState(false);
  const [kpiRequestData, setKpiRequestData] = useState({});

  const handleToggleKpiModal = () => {
    setKpiModal(!kpiModal);
  };

  const handleGenerateReport = async () => {
    try {
      const response = await dispatch(refreshKpiReportData()).unwrap();

      if (response?.status === 200 || response?.status === 201) {
        setKpiRequestData(response?.data?.data);
        setKpiModal(true);
        setIsPolling(true);
      }
    } catch {
      //handle error
    }
  };

  useEffect(() => {
    let intervalId = null;
    const fetchKpiReportStatusOnce = async () => {
      try {
        const response = await dispatch(refreshKpiReportDataGet()).unwrap();
        dispatch(setKpiRequestDataStatus(response?.data?.data));
        const reportStatus = response?.data?.data?.status;
        dispatch(setKpiRequestDataStatus(response?.data?.data));
        if (reportStatus !== "COMPLETED") {
          intervalId = setTimeout(fetchKpiReportStatusOnce, 10000);
        }
      } catch {
        // handle catch here;
      }
    };
    fetchKpiReportStatusOnce();
    return () => {
      if (intervalId) clearTimeout(intervalId);
    };
  }, []);

  useEffect(() => {
    if (!isPolling) return;

    let intervalId = null;

    const handleKpiRefreshDataStatus = async () => {
      try {
        const response = await dispatch(refreshKpiReportDataGet()).unwrap();
        const reportStatus = response?.data?.data?.status;
        dispatch(setKpiRequestDataStatus(response?.data?.data));
        if (reportStatus !== "COMPLETED") {
          intervalId = setTimeout(handleKpiRefreshDataStatus, 10000);
        } else {
          setIsPolling(false);
        }
      } catch {
        setIsPolling(false);
      }
    };

    handleKpiRefreshDataStatus();

    return () => {
      if (intervalId) clearTimeout(intervalId);
    };
  }, [isPolling, dispatch]);

  useEffect(() => {
    if (kpiRefreshErrorData) {
      setKpiModal(true);
    }
  }, [kpiRefreshErrorData]);

  return (
    <>
      <div className="row mb-2 mx-0">
        <div className="col-12 sales-page-title-wrap sub-heading-blog-wrap pb-2">
          <div className="row box-heading">
            <div className="col-md-12 d-flex flex-wrap align-items-center">
              <h2>{subheading}</h2>
              <div
                className={`${styles.lastUpdateLabel} refresh-btn d-flex align-items-center`}
              >
                {kpiReportText.labels.kpiLastUpdated}
                {kpiRequestDataStatus?.completedTimeAgo === null
                  ? commonText?.underProcessing
                  : kpiRequestDataStatus?.completedTimeAgo}
                <button
                  className="btn btn-primary btn-small ms-1"
                  onClick={handleGenerateReport}
                >
                  {kpiReportText.labels.btn}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <KpiRefreshDataModal
        isOpen={kpiModal}
        toggle={handleToggleKpiModal}
        kpiRequestData={kpiRequestData}
        kpiRefreshErrorData={kpiRefreshErrorData}
      />
    </>
  );
};
KpiReportPageAction.propTypes = {
  subheading: PropTypes.string.isRequired
};

export default KpiReportPageAction;
